import AdvancedController from "./advanced-controller"


export default class KeyvisualController extends AdvancedController {

  static targets = [
    'toggle',
    'modal',
  ];



  onToggleClick() {
    const modalVideoUrl = this.modalTarget.querySelector('#modal-video__url').textContent;

    this.modalTarget.classList.toggle('is-active');

    //src of modalvideo is empty by default and gets set to the url of the video if the modal is open
    // fixes autoplay problem in firefox 

    let modalVideo = this.modalTarget.querySelector('video');
    if (this.modalTarget.classList.contains('is-active')) {
      modalVideo.src = modalVideoUrl;
    } else {
      modalVideo.src = '';
    }
  }

}
